export default class GraperVariety {
	constructor() {
		this.id = null;
		this.title = null;
		this.wineTypes = [];
		this.curated = false;
		this.lands = [];
	}
}